/***/
/**
 * Web library for the Heroku plugin.
 */

import { createApiRef, ApiRef } from '@backstage/core-plugin-api';

import {
  HerokuPlatformApiApp,
  HerokuPlatformApiPipeline,
  HerokuPlatformApiPipelineCoupling,
} from '@heroku-cli/typescript-api-schema';

/**
 * Interface for interacting with Heroku. The main implementation for this is
 * located in the Heroku plugin.  Projects may depend on this interface but will
 * need the Heroku plugin to provide the implementation at run time.
 */
export interface HerokuApi {
  listPipelineCouplings: (
    pipelineId: string,
  ) => Promise<HerokuPlatformApiPipelineCoupling[]>;
  getPipeline: (
    pipelineId: string,
    pipelineName?: string,
  ) => Promise<HerokuPlatformApiPipeline>;
  getApp: (appId: string) => Promise<HerokuPlatformApiApp>;
  getApps: (pipelineId: string) => Promise<HerokuPlatformApiApp[]>;
}

/**
 * Backstage ApiRef for interacting with Heroku.  The Heroku plugin will provide
 * a default implementation of this interface at run time which can be requested
 * with `useApi(herokuApiRef)`.
 */
export const herokuApiRef: ApiRef<HerokuApi> = createApiRef<HerokuApi>({
  id: 'plugin.heroku.api',
});
